import React from 'react'



const filterCacheKey = 'filterCacheKey'

const  getFilterComponentCache = (key:string)=>{
  try{
    let cache = window.sessionStorage.getItem(filterCacheKey)
    if(cache){
      let obj = JSON.parse(cache)
      return obj[key]
    }
  }catch(e){
    console.error(e)
  }
}
const setFilterComponentCache  = (key:string,value:any)=>{
  try{
    let cache = window.sessionStorage.getItem(filterCacheKey)
    let obj:Record<string,any> = {}
    if(cache){
      obj = JSON.parse(cache);
      if(!obj){
        obj =  {}
      } 
    }
    obj[key] = value
    window.sessionStorage.setItem(filterCacheKey,JSON.stringify(obj))  
  }catch(e){
    console.error(e)
  }
}


export type useSelectModalListType<T> = {
  listKey: keyof T extends string? keyof T : string  ,  //列表唯一key
  initState?: T[]
  value?:any 
  componentKey?:string //缓存组件options的值的key
}


export const useSelectModalList = <T extends Record<string,any>>(props: useSelectModalListType<T>) => {
  const { listKey,initState} = props
  let [list,setList] = React.useState<T[]>(initState || [] );
  let [isFetchCache,setIsFetchCache] = React.useState(false);
  const prependList = (moreList:T[])=>{
    let newList: T[] = []
    moreList.forEach(sourceItem => {
      let item = list.find(item => item[listKey] == sourceItem[listKey]);
      if (!item) {
        newList.push(sourceItem)
      }
    })
    if (newList.length) {
      // setList(preList => {
      //   return  [...newList, ...preList] as T[]
      // })
      setListInternal([...newList, ...list])
    }
  }

  const getListCatch = (componentKey: string) => {
    let list = getFilterComponentCache(componentKey) || [];
    setList(list)
  }

  React.useEffect(()=>{
    if(props.componentKey ){
      let hasArrayValue = Array.isArray(props.value) && props.value.length 
      if(!props.value || !hasArrayValue){
        return
      }
      let list = getFilterComponentCache(props.componentKey) || [];
      setList(list)
    }
    setIsFetchCache(true)
  },[])
  const setListInternal = (list:T[])=>{
    if(props.componentKey){
      setFilterComponentCache(props.componentKey,list)
    }
    setList(list)
  }
  return {
    list,
    setList:setListInternal,
    prependList,
    isFetchCache,
  }
}